module.exports = __webpack_public_path__ + "img/smakraft.d89bfccd.jpg";